var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.857143C0 0.383756 0.383755 0 0.857143 0H4.15385C4.17529 0 4.19656 0.000787748 4.21761 0.00233589H11.7843C11.8048 0.000852841 11.8255 0.000103814 11.8462 0.000103814H15.1429C15.6162 0.000103814 16 0.383859 16 0.857247V4.15438C16 6.27925 14.4046 8.03148 12.3462 8.27844C11.8349 9.84324 10.502 11.0364 8.85714 11.3484V14.2858H11.8462C12.3195 14.2858 12.7033 14.6696 12.7033 15.1429C12.7033 15.6163 12.3195 16.0001 11.8462 16.0001H8.03001C8.02005 16.0004 8.01005 16.0006 8 16.0006C7.98995 16.0006 7.97995 16.0004 7.96999 16.0001H4.15384C3.68046 16.0001 3.2967 15.6163 3.2967 15.1429C3.2967 14.6696 3.68046 14.2858 4.15384 14.2858H7.14286V11.3484C5.49805 11.0364 4.16515 9.84324 3.65379 8.27844C1.59547 8.03148 0 6.27925 0 4.15438V0.857143ZM3.29671 6.43911V1.71429H1.71429V4.15438C1.71429 5.20008 2.37222 6.09212 3.29671 6.43911ZM12.7033 1.71439V6.43911C13.6278 6.09212 14.2857 5.20008 14.2857 4.15438V1.71439H12.7033Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.e46d2591291c6149ee425b7bf3569ece.svg";
export { ForwardRef as ReactComponent };